import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNotebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#0D1B27"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.87}
      strokeWidth={1.5}
    >
      <path
        d="M18.003 21.004H5.998a2 2 0 0 1-2.001-2.001V4.997a2 2 0 0 1 2-2h12.006a2 2 0 0 1 2 2v14.006a2 2 0 0 1-2 2"
        clipRule="evenodd"
      />
      <path d="M8.999 7.998h7.003M8.999 16.002h1M16.613 15.53l-1.946 1.945-1.166-1.167M8.999 12h7.003M2.496 7.998h3.001M2.496 16.002h2.802M2.496 12h2.802" />
    </g>
  </svg>
);
export default SvgNotebook;
